import { memo } from 'react';
import { Stack, Typography } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { useWhiteLabelContext } from '@aibees/elephant/feature/white-label/context';
import * as Styled from './styles';
import * as SX from './sx';
import type { HeaderLogoProps as Props } from './types';

export const HeaderLogo = memo(({ className }: Props) => {
  const { headerLogo, primaryColor, companyName } = useWhiteLabelContext();

  const logoUrl = headerLogo.value
    ? URL.createObjectURL(headerLogo.value as any)
    : null;

  const color = !primaryColor.error ? primaryColor.value : undefined;

  return (
    <Styled.Wrapper
      className={classnames('HeaderLogo', className)}
      title="Header Logo"
      description="33px X 33px"
      tooltipContent="Recommended dimensions: 33px by 33px. This logo appears in the header."
    >
      <Stack sx={SX.container(color)} direction="row">
        <Stack sx={SX.logoContainer(color)}>
          {logoUrl ? (
            <img src={logoUrl} alt="Logo" />
          ) : (
            <Styled.Logo src="/assets/images/ark-logo.svg" alt="logo" />
          )}
        </Stack>
        <Stack sx={SX.content} justifyContent="center">
          <Typography sx={SX.text1}>{companyName.value || 'AI ARK'}</Typography>
          <Stack direction="row">
            <Typography sx={SX.text2}>Home /</Typography>
            <Typography sx={SX.text3}>People Search</Typography>
          </Stack>
        </Stack>
      </Stack>
    </Styled.Wrapper>
  );
});

HeaderLogo.displayName = 'HeaderLogo';
